import { getChatDocumentsApi } from '@/api/chat/getChatDocuments';
import type { AppDispatch } from '@/store/store';

interface ResolveExistingDocumentIdsArgs {
  dispatch: AppDispatch;
  chatId: string;
  clientDocumentIds: string[];
}

/** `chat.documents` is empty right after a chat switch, so merge in the server list at send time. */
export const resolveExistingDocumentIds = async ({
  dispatch,
  chatId,
  clientDocumentIds,
}: ResolveExistingDocumentIdsArgs): Promise<string[]> => {
  if (!chatId) return clientDocumentIds;

  try {
    const result = await dispatch(
      getChatDocumentsApi.endpoints.getChatDocuments.initiate({ chatId }, { subscribe: false }),
    ).unwrap();

    // `documents`, not `allDocuments`: the send endpoint 404s on the draft ids the latter carries.
    const serverDocumentIds = (result?.documents ?? []).map((document) => document.documentId);

    return Array.from(new Set([...clientDocumentIds, ...serverDocumentIds]));
  } catch (error) {
    // The message itself must never be blocked by the document list failing to load.
    console.error('Failed to resolve chat documents for send:', error);
    return clientDocumentIds;
  }
};
